import { customElement } from "lit/decorators.js";
import { FeaturedIcon } from "@/components/featured-icon";

@customElement("eko-card-icon")
export class CardIcon extends FeaturedIcon {
  constructor() {
    super();
    this.variant = "circular-light";
    this.size = "lg";
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-card-icon": CardIcon;
  }
}

export default CardIcon;
